export default function HeroImage() {
    return (
        <div className="pointer-events-none absolute bottom-0 right-16 z-20 hidden h-[75%] w-[40%] lg:block xl:right-20 2xl:right-50">
            <img
                src="/assets/law_woman.png"
                alt=""
                aria-hidden="true"
                className="h-full w-full object-contain object-bottom"
            />
            {/* Gradient fade at the bottom of the hero image */}
            <div className="w-[400px] m-auto absolute inset-x-0 bottom-0 h-28 bg-linear-to-b from-transparent to-[#F6F6F6]" />
        </div>
    );
}
